// FILE: src/pages/profile/ProfileDisplayPage.jsx
// My profile › Display & accessibility (plan WP-8 tasks 5–6; MTO 5.1–5.4,
// CD5.2 AODA): theme, text size, reduced motion, plus how to ask for an
// accommodation. Settings are kept in this browser.
import React from "react";
import { Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ProfileShell from "../../components/profile/ProfileShell";
import { Section } from "../../components/ui";
import { DisplaySettingsPanel } from "../../components/shell/DisplaySettings";

export default function ProfileDisplayPage() {
  return (
    <ProfileShell title="Display & accessibility" description="Make the site easier to read and use on this device.">
      <Stack spacing={3}>
        <Section id="display" title="Display">
          <DisplaySettingsPanel />
        </Section>
        <Section id="a11y-help" title="Accessibility support">
          <Stack spacing={1.5}>
            <Typography>
              The site works with screen readers, keyboard-only use, browser zoom up to 200% and high-contrast
              settings. Lessons have closed captions, and you can pause, replay and control the volume of every video.
            </Typography>
            <Typography>
              Need something else, such as more time between identity checks, a different format for a document, or
              help using the site? Ask{" "}
              <Link component={RouterLink} to="/student/support/new">
                student service support
              </Link>
              . We'll work with you on an accommodation.
            </Typography>
          </Stack>
        </Section>
      </Stack>
    </ProfileShell>
  );
}
